import { Code, Stack, Text, TextInput } from "@mantine/core";

import { t } from "@/i18n";

/**
 * The organization control on an authoring surface.
 *
 * Renders an editable input for Medicus staff, and a read-only display for a
 * tenant-scoped `ClientAdmin` — whose organization comes from their token and
 * cannot be changed. There is deliberately no disabled-input variant: a greyed
 * text box invites the question "why can't I edit this?", whereas a labelled
 * value simply states which organization you are working in.
 */

interface TenantFieldProps {
  org: string;
  pinned: boolean;
  onChange: (org: string) => void;
}

export function TenantField({ org, pinned, onChange }: TenantFieldProps): JSX.Element {
  if (pinned) {
    return (
      <Stack gap={2}>
        <Text size="sm" fw={500}>
          {t("authoring.org_pinned_label")}
        </Text>
        <Code>{org}</Code>
      </Stack>
    );
  }
  return (
    <TextInput
      label={t("authoring.org_filter")}
      placeholder={t("authoring.org_placeholder")}
      value={org}
      onChange={(event) => onChange(event.currentTarget.value)}
    />
  );
}
